<!-- START Dialog: Try with hardware -->
<p-dialog header="" [(visible)]="showDialog" [style]="{ width: '40vw' }" [closable]="true" [closeOnEscape]="true" [modal]="true">
    <div
        class="text-center mb-16"
        style="
            background-image: url(&quot;../../../../assets/images/buzzer-colors.png&quot;);
            height: 16vh;
            background-size: contain;
            background-repeat: no-repeat;
            background-position-x: center;
        "
    ></div>

    <ng-template pTemplate="content">
        <h1 class="mb-4 text-center">{{ "dialog_tryhardware_header" | translate }}</h1>
        <p class="mb-12 text-center">{{ "dialog_tryhardware_text1" | translate }}</p>

        <ul class="feature-list text-center">
            <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_tryhardware_bullet1" | translate }}</li>
            <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_tryhardware_bullet2" | translate }}</li>
            <li class="mb-6"><i class="feature-icon pi pi-check-circle"></i>{{ "dialog_tryhardware_bullet3" | translate }}</li>
        </ul>
    </ng-template>

    <ng-template pTemplate="footer">
        <div class="flex justify-center">
            <p-button pRipple type="button" styleClass="p-button-text" label="{{ 'dialog_tryhardware_button_later' | translate }}" (click)="onHide.emit()">
            </p-button>
            <p-button
                pRipple
                type="button"
                styleClass="p-button"
                (click)="tryHardware.emit()"
                label="{{ 'dialog_tryhardware_button_order' | translate }}"
            ></p-button>
        </div>
    </ng-template>
</p-dialog>
<!-- END Dialog: Try with hardware -->
